import { IPassport, ILinkRemotePassportToCaseRequest } from 'src/shared/types/ImmigrationDocument';
import { createApiFetcher, createApiPoster } from 'src/utils/ApiUtils';

const fetchData = createApiFetcher('passports/');
const postData = createApiPoster('passports/');

export const getPassportDetails = async (
  beneId: number | undefined,
  dependentId: number | undefined
): Promise<IPassport[]> => fetchData<IPassport[]>(`details?beneId=${beneId ?? ''}&dependentId=${dependentId ?? ''}`);

export const getBeneficiaryPassports = async (beneId?: number, dependentId?: number): Promise<IPassport[]> => {
  const params = new URLSearchParams();
  if (beneId) params.append('beneId', beneId.toString());
  if (dependentId) params.append('dependentId', dependentId.toString());
  return fetchData<IPassport[]>(`passportinfo?${params.toString()}`);
};

export const linkRemotePassportToCase = async (request: ILinkRemotePassportToCaseRequest): Promise<void> => {
  return await postData('link-remote-passport-to-case', request);
};
